import { useDialog } from '@dni-hooks/useDialog'
import type { ValueOf } from '@dni-types/utilities/value-of'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'

export const DIALOG_CSV_VALIDATION_RESULT = 'DIALOG_CSV_VALIDATION_RESULT'

export const CSV_VALIDATION_ERROR_LEVEL = {
  FILE: 'file',
  ROW: 'row',
} as const

export type CsvValidationErrorLevelType = ValueOf<typeof CSV_VALIDATION_ERROR_LEVEL>

export interface DialogCsvValidationResultProps {
  errorLevel: CsvValidationErrorLevelType
  lines: string[]
}

export const DialogCsvValidationResult = () => {
  const { open, closeDialog, errorLevel, lines } = useDialog<DialogCsvValidationResultProps>(DIALOG_CSV_VALIDATION_RESULT)
  const isMobile = useResponsive('mobile')

  return (
    <Dialog open={open} maxWidth={isMobile ? 320 : 480} fullWidth>
      <DialogHeader title="檔案驗證結果" onClose={closeDialog} />
      <DialogContent py={3}>
        <VStack gap={4}>
          {errorLevel === CSV_VALIDATION_ERROR_LEVEL.ROW && <Text color={colors.grey800}>以下資料有誤，請修正檔案後再次送出！</Text>}
          <VStack>
            {lines?.map(line => <Text key={line} color={colors.grey800}>{line}</Text>)}
          </VStack>
        </VStack>
      </DialogContent>
      <DialogActions>
        <Button backgroundColor={colors.black} fullWidth onClick={closeDialog}>我知道了</Button>
      </DialogActions>
    </Dialog>
  )
}
